<template>
  <div id="contenedor-main-estimaciones-reportes-penas-convencionales">
    <!-- Generales -->
    <div class="white mb-5">
      <v-row justify="space-between">
        <v-col cols="6">
          <v-row no-gutters>
            <v-col cols="12">
              <h3>CONTRATO</h3>
              {{ contrato.meta }}
            </v-col>
            <v-col cols="12">
              <h3>CONTRATISTA</h3>
              {{ contrato.contratista.nombreRazonSocial }}
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="5">
          <v-row>
            <v-col cols="6">
              <v-row no-gutters>
                <v-col cols="12" class="font-weight-bold">
                  ESTIMACIÓN No. {{ estimacion.numero }}
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="6">
              <v-row no-gutters>
                <v-col cols="12" class="font-weight-bold">PERIODO:</v-col>
                <v-col cols="12" class="text-uppercase">
                  {{ new Date(`${estimacion.fechaDel} 00:00:0`)
                  .toLocaleDateString('es-MX', { year: 'numeric',
                  month: 'long', day: 'numeric' }) }}
                  AL
                  {{ new Date(`${estimacion.fechaAl} 00:00:0`)
                  .toLocaleDateString('es-MX', { year: 'numeric',
                  month: 'long', day: 'numeric' }) }}
                </v-col>
                <v-col cols="12" class="font-weight-bold">FECHA DE PRESENTACIÓN</v-col>
                <v-col cols="12" class="text-uppercase">
                  {{ new Date(`${estimacion.fechaPresentacion} 00:00:0`).toLocaleDateString() }}
                </v-col>
                <v-col cols="12" class="font-weight-bold">FECHA DE AUTORIZACIÓN</v-col>
                <v-col cols="12" class="text-uppercase">
                  {{ new Date(`${estimacion.fechaAutorizacion} 00:00:0`).toLocaleDateString() }}
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>
    <!-- Datos del contrato -->
    <div class="white rounded-xl mb-5">
      <v-row>
        <v-col cols="12">
          <v-card tile outlined class="text-center base4">DATOS DE CONTRATACIÓN</v-card>
          <v-row justify="space-between" align="start" class="text-center">
            <v-col cols="2">
              <span class="font-weight-bold">NÚM. CONTRATO</span>
              <v-row no-gutters>
                <v-col cols="12">{{ contrato.numero }}</v-col>
              </v-row>
            </v-col>
            <v-col cols="2">
              <span class="font-weight-bold">FECHA</span>
              <v-row no-gutters>
                <v-col cols="12">{{ new Date(contrato.fecha).toLocaleDateString() }}</v-col>
              </v-row>
            </v-col>
            <v-col cols="2">
              <span class="font-weight-bold">
                IMPORTE TOTAL
                <template
                  v-if="contrato.esObraFinanciada">
                  (Sin Financiamiento)
                </template>
              </span>
              <v-row no-gutters>
                <v-col cols="12">{{ importeDelContratoEnPenasConvencionales | currency }}</v-col>
              </v-row>
            </v-col>
            <v-col cols="2">
              <span class="font-weight-bold">FECHA INICIO</span>
              <v-row no-gutters>
                <v-col cols="12">
                  {{ new Date(`${estimacion.fechaInicioContrato} 00:00:0`).toLocaleDateString() }}
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="2">
              <span class="font-weight-bold">FECHA TERMINO</span>
              <v-row no-gutters>
                <v-col cols="12">
                  {{ new Date(`${estimacion.fechaTerminoContrato} 00:00:0`).toLocaleDateString() }}
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>

  <div class="white rounded-xl mb-5">
    <v-row justify="space-between"><v-col>
    <v-card tile outlined class="text-center base4">CONVENIOS MODIFICATORIOS</v-card>
    <v-data-table
      :headers="headers"
      :items="listadoConvenios"
      :items-per-page="20">
       <template v-slot:[`item.fecha`]="{ item }">
        {{ new Date(`${item.fecha} 00:00:0`).toLocaleDateString() }}
      </template>
      <template v-slot:[`item.numero`]="{ item }">
          {{ item.numero }}
      </template>
      <template v-slot:[`item.tipo`]="{ item }">
          {{ item.tipo }}
      </template>
      <template v-slot:[`item.importe`]="{ item }">
        <template  v-if="item.tipo === 'MONTO - AMPLIACIÓN'
        || item.tipo === 'MONTO - REDUCCIÓN'
        || item.tipo === 'PLAZO - MONTO AMPLIACIÓN'">
          {{ item.importe | currency }}
        </template>
      </template>

      <template v-slot:[`item.fechaInicio`]="{ item }">
        <template  v-if="item.tipo === 'PLAZO'
        || item.tipo === 'REPROGRAMACIÓN'
        || item.tipo === 'PLAZO - MONTO AMPLIACIÓN'">
          <span class="font-weight-medium">
            {{ new Date(`${item.fechaInicio} 00:00:0`).toLocaleDateString() }}
          </span>
        </template>
        </template>
      <template v-slot:[`item.fechaTermino`]="{ item }">
        <template  v-if="item.tipo === 'PLAZO'
        || item.tipo === 'REPROGRAMACIÓN'
        || item.tipo === 'PLAZO - MONTO AMPLIACIÓN'">
      <span class="font-weight-medium">
        {{ new Date(`${item.fechaTermino} 00:00:0`).toLocaleDateString() }}
      </span>
        </template>
    </template>
    </v-data-table>
    </v-col></v-row>
  </div>

    <div class="white rounded-xl">
      <v-row justify="space-between">
        <template
          v-if="estimacion.importeSancion <= 0">
          <v-col cols="12" md="6">
            <v-list dense subheader>
              <v-subheader>RETENCIÓN O DEVOLUCIÓN (DENTRO DE PROGRAMA):</v-subheader>
              <v-list-item link>
                <v-list-item-content>
                  <v-list-item-title>MONTO PROGRAMADO PARA ESTA ESTIMACIÓN</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  {{ importeProgramadoEstaEstimacion | currency }}
                </v-list-item-action>
              </v-list-item>
              <v-list-item link>
                <v-list-item-content>
                  <v-list-item-title>MONTO EJECUTADO REAL PARA ESTA ESTIMACIÓN</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  {{ importeEjecutadoEstaEstimacion | currency }}
                </v-list-item-action>
              </v-list-item>
              <v-divider></v-divider>
              <template
                v-if="tipo === 'baseDias'">
                <v-list-item link>
                  <v-list-item-content>
                    <v-list-item-title>DÍAS DE PROGRAMA</v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-action>
                    {{ getProgramaEnPenasConvencionales.diasTranscuridos }}
                  </v-list-item-action>
                </v-list-item>
                <v-list-item link>
                  <v-list-item-content>
                    <v-list-item-title>MONTO DIARIO PROGRAMADO</v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-action>
                    {{ montoDiarioProgramado | currency }}
                  </v-list-item-action>
                </v-list-item>
                <v-list-item link>
                  <v-list-item-content>
                    <v-list-item-title>
                      DIAS EJECUTADOS REALES
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      CON RELACIÓN AL MONTO DIARIO PROGRAMADO
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>
                    {{ diasEjecutadosReales }}
                  </v-list-item-action>
                </v-list-item>
                <v-list-item link>
                  <v-list-item-content>
                    <v-list-item-title>
                      DIAS DE DESFASAMIENTO
                    </v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-action>
                    {{ diasDeDesfazamiento }}
                  </v-list-item-action>
                </v-list-item>
                <v-list-item link>
                  <v-list-item-content>
                    <v-list-item-title>
                      MONTO DE ATRASO
                    </v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-action>
                    {{ montoDeAtraso | currency }}
                  </v-list-item-action>
                </v-list-item>
                <v-list-item link>
                  <v-list-item-content>
                    <v-list-item-title>
                      PORCENTAJE DIARIO DE RETENCION
                    </v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-action>
                    {{ (porcentajeRetencion * 100) }}%
                  </v-list-item-action>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item link>
                  <v-list-item-content>
                    <v-list-item-title>
                      TOTAL DE LA RETENCIÓN HASTA ESTA ESTIMACIÓN
                    </v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-action>
                    {{ importeRetencionEstaEstimacion | currency }}
                  </v-list-item-action>
                </v-list-item>
                <v-list-item link>
                  <v-list-item-content>
                    <v-list-item-title>RETENIDO ANTERIORMENTE</v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-action>
                    {{ importeRetenidoAnteriormente | currency }}
                  </v-list-item-action>
                </v-list-item>
              </template>
              <template
                v-else>
                <v-list-item link>
                  <v-list-item-content>
                    <v-list-item-title>MONTO ATRASADO PARA ESTA ESTIMACIÓN</v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-action>
                    {{ importeAtrasoEstaEstimacion | currency }}
                  </v-list-item-action>
                </v-list-item>
                <v-list-item link>
                  <v-list-item-content>
                    <v-list-item-title>PORCENTAJE DE RETENCIÓN</v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-action>{{ porcentajeRetencion }}%</v-list-item-action>
                </v-list-item>
                <v-list-item link>
                  <v-list-item-content>
                    <v-list-item-title>
                      TOTAL DE LA RETENCIÓN HASTA ESTA ESTIMACIÓN
                    </v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-action>
                    {{ importeRetencionEstaEstimacion | currency }}
                  </v-list-item-action>
                </v-list-item>
                <v-list-item link>
                  <v-list-item-content>
                    <v-list-item-title>RETENIDO ANTERIORMENTE</v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-chip
                      color="error">
                      {{ importeRetenidoAnteriormente | currency }}
                    </v-chip>
                  </v-list-item-action>
                </v-list-item>
              </template>
              <v-list-item link>
                <v-list-item-content>
                  <v-list-item-title>
                    RETENCION NETA A APLICAR EN ESTA ESTIMACION
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-chip
                    color="error">
                    {{ estimacion.importeRetenido | currency }}
                  </v-chip>
                </v-list-item-action>
              </v-list-item>
              <v-list-item link>
                <v-list-item-content>
                  <v-list-item-title>
                    DEVOLUCION A EFECTUAR EN ESTA ESTIMACION
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-chip
                    color="success">
                    {{ estimacion.importeDevuelto | currency }}
                  </v-chip>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-col>
        </template>
        <template
          v-else>
          <v-col
            cols="12"
            md="6">
            <v-subheader>SANCIÓN (FUERA DE PROGRAMA):</v-subheader>
            <v-list-item link>
              <v-list-item-content>
                <v-list-item-title>MONTO FUERA DE PROGRAMA:</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                {{ montoFueraPrograma | currency }}
              </v-list-item-action>
            </v-list-item>
            <v-list-item link>
              <v-list-item-content>
                <v-list-item-title>DÍAS DE ATRASO:</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                {{ diasDeAtraso }}
              </v-list-item-action>
            </v-list-item>
            <v-list-item link>
              <v-list-item-content>
                <v-list-item-title>PORCENTAJE DE SANCIÓN:</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                {{ porcentajeDeSacionEtiqueta }}%
              </v-list-item-action>
            </v-list-item>
            <v-divider></v-divider>
            <v-list-item link>
              <v-list-item-content>
                <v-list-item-title>
                  SANCION A APLICAR EN ESTA ESTIMACIÓN:
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                {{ sancionAplicarEstaEStimacion | currency }}
              </v-list-item-action>
            </v-list-item>
            <v-list-item link>
              <v-list-item-content>
                <v-list-item-title>
                  SANCIONES ANTERIORES:
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                {{ sumaSancionesAnteriores | currency }}
              </v-list-item-action>
            </v-list-item>
            <v-list-item link>
              <v-list-item-content>
                <v-list-item-title>
                  SANCION NETA:
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-chip
                  color="error">
                  {{ estimacion.importeSancion | currency }}
                </v-chip>
              </v-list-item-action>
            </v-list-item>
            <v-divider></v-divider>
            <v-list-item link>
              <v-list-item-content>
                <v-list-item-title>RETENIDO ANTERIORMENTE</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-chip
                  color="error">
                  {{ importeRetenidoAnteriormente | currency }}
                </v-chip>
              </v-list-item-action>
            </v-list-item>
            <v-list-item link>
              <v-list-item-content>
                <v-list-item-title>
                  DEVOLUCION A EFECTUAR EN ESTA ESTIMACION
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-chip
                  color="success">
                  {{ estimacion.importeDevuelto | currency }}
                </v-chip>
              </v-list-item-action>
            </v-list-item>
          </v-col>
        </template>
      </v-row>
    </div>
    <!-- Firmas -->
    <div class="mt-3">
    </div>
  </div>
</template>

<script>
// import Firma from '@/components/Firma.vue';
import mixDescargaPenasConvencionales from './mixDescargaPenasConvencionales';

export default {
  name: 'MainEstimacionesReportePenasConvencionales',
  components: {
  },
  mixins: [
    mixDescargaPenasConvencionales],
  props: {
    estimacion: {
      type: Object,
      required: true,
    },
    estimaciones: {
      type: Array,
      required: true,
    },
    contrato: {
      type: Object,
      required: true,
    },
    firmas: {
      type: Array,
      required: false,
    },
  },
  data() {
    return {
      tipo: 'baseDias',
      importeProgramadoEstaEstimacion: 0,
      importeEjecutadoEstaEstimacion: 0,
      importeAtrasoEstaEstimacion: 0,
      porcentajeRetencion: (this.contrato.porcentajeRetencion / 100),
      importeRetenidoAnteriormente: 0,
      importeRetencionAplicarEstaEstimacion: 0,
      importeDevolucionEstaEstimacion: 0,
      porcentajeSancion: (this.contrato.porcentajeSancion / 100),
      porcentajeDeSacionEtiqueta: this.contrato.porcentajeSancion,
      headers: [
        {
          text: 'Fecha',
          value: 'fecha',
          align: 'center',
          sortable: false,
        },
        {
          text: 'Número',
          align: 'start',
          sortable: false,
          value: 'numero',
        },
        {
          text: 'Tipo',
          align: 'start',
          sortable: false,
          value: 'tipo',
        },
        {
          text: 'Importe',
          value: 'importe',
          align: 'end',
          sortable: false,
        },
        {
          text: 'F. Inicio',
          value: 'fechaInicio',
          align: 'center',
          sortable: false,
        },
        {
          text: 'F. Término',
          value: 'fechaTermino',
          align: 'center',
          sortable: false,
        },
      ],
    };
  },
  mounted() {
    this.calcular();
  },
  methods: {
    /*
    formatoObjeto(objeto) {
      return this.formatoEstructura(objeto);
    },
    async generarPdf() {
      this.$emit('generando');
      const contratoConFormato = this.formatoObjeto(this.contrato);
      const estimacionConFormato = this.formatoObjeto(this.estimacion);
      const supervisor = this.getSupervisorEnPenasConvencionales || '';
      // const firmasFuncionarios = this.firmas;
      const datosCalculados = {
        tipo: this.tipo,
        diasTranscuridos: this.getProgramaEnPenasConvencionales.diasTranscuridos,
        importeDelContrato: this.importeDelContratoEnPenasConvencionales,
        importeProgramadoEstaEstimacion: this.importeProgramadoEstaEstimacion,
        importeEjecutadoEstaEstimacion: this.importeEjecutadoEstaEstimacion,
        montoDiarioProgramado: this.montoDiarioProgramado,
        diasEjecutadosReales: this.diasEjecutadosReales,
        diasDeDesfazamiento: this.diasDeDesfazamiento,
        montoDeAtraso: this.montoDeAtraso,
        porcentajeRetencion: (this.porcentajeRetencion * 100),
        importeRetencionEstaEstimacion: this.importeRetencionEstaEstimacion,
        importeRetenidoAnteriormente: this.importeRetenidoAnteriormente,
        montoFueraPrograma: this.montoFueraPrograma,
        diasDeAtraso: this.diasDeAtraso,
        porcentajeSancion: this.porcentajeSancion,
        sancionAplicarEstaEStimacion: this.sancionAplicarEstaEStimacion,
        sumaSancionesAnteriores: this.sumaSancionesAnteriores,
        importeAtrasoEstaEstimacion: this.importeAtrasoEstaEstimacion,
        seccionRetencionSancion: this.seccionRetencionSancion,
      };
      const datos = this.formatoObjeto(datosCalculados);
      const nombreTemplate = 'templatePenasConvencionales';
      await this.mixGenerarPdf({
        configuracion: {
          path: 'wepp/wep',
          PUPPETEER_CONFIGURACION: {
            landscape: true,
            format: 'A3',
          },
          nombreTemplate,
        },
        data: {
          contrato: contratoConFormato,
          estimacion: estimacionConFormato,
          supervisor,
          firmas: '',
          datos,
          footer: '',
        },
      }, `${this.contrato.numero}_PenasConvencionales_Estimacion_${this.estimacion.numero}`);
      this.$emit('terminando');
    },

    calcular() {
      this.importeProgramadoEstaEstimacion = this.estimacion.importeMontoProgramado;
      this.importeEjecutadoEstaEstimacion = this.acumuladoTotal;
      this.importeAtrasoEstaEstimacion = this.importeProgramadoEstaEstimacion
        - this.importeEjecutadoEstaEstimacion;
      this.importeRetencionEstaEstimacion = this.montoDeAtraso
      * (this.porcentajeRetencion);
      this.importeRetenidoAnteriormente = this.importeTotalRetenidoAnteriormente;
    },
    */
  },
  computed: {
    /*
    listadoConvenios() {
      if (!this.contrato.convenios) return [];
      return this.contrato.convenios
        .filter((c) => c.fecha <= this.estimacion.fechaAl)
        .filter((c) => c.tipo.includes('PLAZO') || c.tipo.includes('MONTO'))
        .sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));
    },
    *
    /*
    importeDelContratoEnPenasConvencionales() {
      return this.estimacion.importeContratoSinFinanciamiento;
    },
    numeroEstimacionEnPenasConvencionales() {
      return Number(this.estimacion.numero);
    },
    getProgramaEnPenasConvencionales() {
      return this.mixCalcularPrograma(this.estimacion.fechaAl);
    },
    montoDiarioProgramado() {
      const { diasTranscuridos } = this.getProgramaEnPenasConvencionales;
      return (this.estimacion.importeMontoProgramado / diasTranscuridos);
    },
    diasEjecutadosReales() {
      return Math.floor((this.importeEjecutadoEstaEstimacion / this.montoDiarioProgramado));
    },
    diasDeDesfazamiento() {
      const { diasTranscuridos } = this.getProgramaEnPenasConvencionales;
      const diasDesfasamiento = (diasTranscuridos - this.diasEjecutadosReales);
      if (diasDesfasamiento < 0) return 0;
      return diasDesfasamiento;
    },
    montoDeAtraso() {
      const monto = (this.diasDeDesfazamiento * this.montoDiarioProgramado);
      if (monto < 0) return 0;
      return monto;
    },
    contratoTotalAnticipoEnPenasConvencionales() {
      return this.$ObjSumar(this.contrato.anticipos, 'importe');
    },
    estimacionesAnterioresEnPenasConvencionales() {
      return this.estimaciones.filter(
        ({ numero }) => Number(numero) < this.numeroEstimacionEnPenasConvencionales,
      );
    },
    amortizacionAnticipoAcumuladoAnterirorEnPenasConvencionales() {
      return this.$ObjSumar(
        this.estimacionesAnterioresEnPenasConvencionales,
        'importeAmortizacionAnticipo',
      );
    },
    amortizacionAnticipoAcumuladoTotalEnPenasConvencionales() {
      return (
        this.amortizacionAnticipoAcumuladoAnterirorEnPenasConvencionales
        + this.estimacion.importeAmortizacionAnticipo
      );
    },
    amortizacionAnticipoSaldoEnPenasConvencionales() {
      return (
        this.contratoTotalAnticipoEnPenasConvencionales
        - this.amortizacionAnticipoAcumuladoTotalEnPenasConvencionales
      );
    },
    estimadoAcumuladoAnterirorEnPenasConvencionales() {
      return this.$ObjSumar(this.estimacionesAnterioresEnPenasConvencionales, 'importeEstimado');
    },
    acumuladoTotal() {
      return this.estimacion.importeEstimado + this.estimadoAcumuladoAnterirorEnPenasConvencionales;
    },
    importeTotalRetenidoAnteriormente() {
      const retenidoAnterior =
      this.$ObjSumar(this.estimacionesAnterioresEnPenasConvencionales, 'importeRetenido');
      const retenidoDevuelto =
      this.$ObjSumar(this.estimacionesAnterioresEnPenasConvencionales, 'importeDevuelto');
      return (retenidoAnterior - retenidoDevuelto);
    },
    importeRetencionNetaAplica() {
      const importe = this.importeRetencionEstaEstimacion - this.importeTotalRetenidoAnteriormente;
      if (importe <= 0) return 0;
      return importe;
    },
    ordenarListadoFirmasEnPenasConvencionales() {
      if (!this.firmas) return [];
      return this.firmas.slice().sort((a, b) => a.orden - b.orden);
    },
    estimacionesDentroPrograma() {
      const estimacionFinPrograma = this.estimaciones
        .find(({ esEstimacionFinPrograma }) => esEstimacionFinPrograma === true);

      if (!estimacionFinPrograma) return [];

      return this.estimaciones
        .filter(
          ({ numero }) => Number(numero) <= Number(estimacionFinPrograma.numero),
        );
    },
    montoFueraPrograma() {
      const montoAnterior = this.$ObjSumar(this.estimacionesDentroPrograma, 'importeEstimado');

      if (this.estimacion.esEstimacionFiniquito) {
        return (this.importeEjecutadoEstaEstimacion - montoAnterior);
      }
      return (this.importeDelContratoEnPenasConvencionales - montoAnterior);
    },
    diasDeAtraso() {
      const { fechaTermino: fechaTerminoPrograma } = this
        .mixGetPrograma[this.mixGetPrograma.length - 1];
      const fechaTerminoEstimacion = this.estimacion.fechaAl;
      return this.calcularDiferenciaEnDias(fechaTerminoPrograma, fechaTerminoEstimacion) - 1;
    },
    sumaSancionesAnteriores() {
      return this.$ObjSumar(this.estimacionesAnterioresEnPenasConvencionales, 'importeSancion');
    },
    sancionAplicarEstaEStimacion() {
      const importeDeAtraso = this.montoFueraPrograma * this.diasDeAtraso;
      return importeDeAtraso * (this.porcentajeSancion / 100);
    },
    getSupervisorEnPenasConvencionales() {
      if (!this.contrato) return null;
      if (!this.contrato.responsables) return null;
      return this.contrato.responsables.find((responsable) => responsable.principal === true);
    },
    seccionRetencionSancion() {
      const estimacionFinPrograma = this.estimaciones
        .find(({ esEstimacionFinPrograma }) => esEstimacionFinPrograma === true);
      if (!this.estimacion.numero) return '';
      if (!estimacionFinPrograma || estimacionFinPrograma.numero >= this.estimacion.numero)
      { return 'retencion'; }
      return 'sancion';
    },
    */
  },
  watch: {
    estimacion: {
      handler() {
        // this.calcular();
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.altura-firmas {
  min-height: 100px;
}
@media print {
  @page {
    size: landscape;
    margin: 0;
  }
}
</style>
